import React, { useCallback } from 'react';
import clsx from 'clsx';
import { TypedMemo } from '../../../common/types';
import styles from './Segmented.module.scss';

export interface SegmentedOption<T extends string> {
  value: T;
  label: React.ReactNode;
}

export interface SegmentedProps<T extends string> {
  options: ReadonlyArray<SegmentedOption<T>>;
  value: T;
  onChange: (value: T) => void;
  className?: string;
  ariaLabel?: string;
}

function SegmentedInner<T extends string>({ options, value, onChange, className, ariaLabel }: SegmentedProps<T>) {
  const handle = useCallback((next: T) => () => onChange(next), [onChange]);
  return (
    <div className={clsx(styles.seg, className)} role="radiogroup" aria-label={ariaLabel}>
      {options.map((option) => (
        <button
          key={option.value}
          type="button"
          role="radio"
          aria-checked={option.value === value}
          className={clsx(option.value === value && styles.on)}
          onClick={handle(option.value)}
        >
          {option.label}
        </button>
      ))}
    </div>
  );
}

export const Segmented = TypedMemo(SegmentedInner) as typeof SegmentedInner;
